import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import RevenueByCustomerShow from './RevenueByCustomerShow';
import { getKoreaRevenueByCustomerDetails, handleLoader } from '../../../../redux/actions/KoreaRevenueByCustomerAction';
import { months } from '../../CompareMonth/helper';
import { setCurrencyFormatInWon } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import {
   sortType
} from '../../helper';

const RevenueByCustomer = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');

  const { revenueByCustomerData, salesChannelFilterData, isLoading } = useSelector(
    ({ koreaRevenueByCustomerReducer, marketPlaceReducer }) =>
    ({
        revenueByCustomerData: koreaRevenueByCustomerReducer?.revenueByCustomerData,
        salesChannelFilterData: marketPlaceReducer.salesChannel,
        isLoading: koreaRevenueByCustomerReducer?.isLoading
    })
  );

  const salesChannelRef = useRef({})

  const [dataToShow, setDataToShow] = useState(revenueByCustomerData?.modal?.data);
  const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [month1, setMonth1] = useState({ year: currentYear });
  const [tempMonth1, setTempMonth1] = useState({ year: currentYear })

  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Korea Revenue By Customer Report ${new Date().getFullYear()}`,
    })
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }


  const callApi = () => {   
    setShowMarketPlaceMessage(false)
    dispatch(handleLoader(true));
    dispatch(getKoreaRevenueByCustomerDetails({
        year: tempMonth1.year,
    }));
  }

  const handleApplyDate = () => {   
      setMonth1(tempMonth1);
      callApi();   
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {
    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } 
  }  

  
  const selectedFromYear = month1.year;  
  
  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="12" md="4">
      <Row className="justify-content-space-between">
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Year</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                  : { value: tempMonth1?.year, label: tempMonth1?.year }}
                options={yearOptions}
                clearable={false}
                placeholder="Select Year"
                className="select_filter-120"
                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'from' : 'to'}
              />
            </div>

          </div>
        </Col>        
      </Row>
    </Col>
  );

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(revenueByCustomerData?.modal?.data);
  }, [revenueByCustomerData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      setShowMarketPlaceMessage(true)
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  const dataToShowForDatesSelected = dataToShow || [];

  const tableHeader = [{
    Header: 'Customer Name',
    accessor: 'customerName',
    disableGlobalFilter: false,
    width: 220,
    sortType
  },
  // {
  //   Header: 'Type',
  //   accessor: 'type',
  //   disableGlobalFilter: false,
  //   width: 120,
  //   sortType
  // },
  {
    Header: `Jan-${tempMonth1.year}`,
    accessor: 'jan',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,    
    sortType,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { jan } = original
      return setCurrencyFormatInWon(Number(jan).toFixed(0), true)
  },
  },
  {
    Header: `Feb-${tempMonth1.year}`,
    accessor: 'feb',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,    
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { feb } = original
      return setCurrencyFormatInWon(Number(feb).toFixed(0), true)
    },
    sortType
  }, {
    Header: `Mar-${tempMonth1.year}`,
    accessor: 'mar',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { mar } = original
      return setCurrencyFormatInWon(Number(mar).toFixed(0), true)
  },
    sortType
  }, {
    Header: `Apr-${tempMonth1.year}`,
    accessor: 'apr',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { apr } = original
      return setCurrencyFormatInWon(Number(apr).toFixed(0), true)
    },
    sortType
  }, {
    Header: `May-${tempMonth1.year}`,
    accessor: 'may',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { may } = original
      return setCurrencyFormatInWon(Number(may).toFixed(0), true)
  },
    sortType
  }
  , {
    Header: `Jun-${tempMonth1.year}`,
    accessor: 'jun',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { jun } = original
      return setCurrencyFormatInWon(Number(jun).toFixed(0), true)
  },
    sortType
  }, {
    Header: `Jul-${tempMonth1.year}`,
    accessor: 'jul',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { jul } = original
      return setCurrencyFormatInWon(Number(jul).toFixed(0), true)
  },
    sortType
  }, {
    Header: `Aug-${tempMonth1.year}`,
    accessor: 'aug',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { aug } = original
      return setCurrencyFormatInWon(Number(aug).toFixed(0), true)
  },
   sortType
  }, {
    Header: `Sep-${tempMonth1.year}`,
    accessor: 'sept',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { sept } = original
      return setCurrencyFormatInWon(Number(sept).toFixed(0), true)
  },
    sortType
  }, {
    Header: `Oct-${tempMonth1.year}`,
    accessor: 'oct',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { oct } = original
      return setCurrencyFormatInWon(Number(oct).toFixed(0), true)
  },
    sortType
  }, {
    Header: `Nov-${tempMonth1.year}`,
    accessor: 'nov',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { nov } = original
      return setCurrencyFormatInWon(Number(nov).toFixed(0), true)
  },
    sortType
  }, {
    Header: `Dec-${tempMonth1.year}`,
    accessor: 'dec',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { dec } = original
      return setCurrencyFormatInWon(Number(dec).toFixed(0), true)
  },
    sortType
  }]

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
        disabled={!dataToShowForDatesSelected?.length}
      >
        View Report
      </button>
    </div>
  )
  
  const modalData = dataToShowForDatesSelected?.map(item => ({
     ...item,
     customerName: `${item.customerName} ( ${item.type} )`,
     jan: Number(item.jan).toFixed(2),
     feb: Number(item.feb).toFixed(2),
     mar: Number(item.mar).toFixed(2),
     apr: Number(item.apr).toFixed(2),
     may: Number(item.may).toFixed(2),
     jun: Number(item.jun).toFixed(2),
     jul: Number(item.jul).toFixed(2),
     aug: Number(item.aug).toFixed(2),
     sept: Number(item.sept).toFixed(2),
     oct: Number(item.oct).toFixed(2),
     nov: Number(item.nov).toFixed(2),
     dec: Number(item.dec).toFixed(2),
   }))
  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Korea Revenue By Customer</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
                <Col sm="12" md="12">
                  <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />                    
                    <Col sm="8" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button>
                        <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col>                   
                  </Row>
                </Col>
                <Col sm="12">
                  <span style={{ color: 'red', alignItems: 'right' }}>
                    {showMarketPlaceMessage ? <small>*Hit Apply to fetch latest data </small> : ''}</span>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>   
      <div id="divToPrint" ref={container}>   
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
             <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <RevenueByCustomerShow
                  dir={rtl.direction}
                  data={dataToShowForDatesSelected}
                  title='Revenue By Customer Chart'
                  viewReportButton={viewReportButton}
                  selectedYear={tempMonth1.year}
                />}
            </div>
          </div> 
        </CardBody>
      </Card>
      </div>
       <ViewSalesReportModal
        modalData={modalData}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        title='Korea Revenue By Customer Report'
        fileName='Korea Revenue By Customer Report'
      /> 
    </Container>
  );
};

RevenueByCustomer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(RevenueByCustomer);